<template>
    <div class="team-biodata">
        <b-card no-body v-if="current_team">
            <b-card-header class="border-0 p-3">
                <b-row align-v="center">
                    <b-col cols="10">
                        <h4 class="mb-0">
                            {{ current_team.hub_team_name }}
                        </h4>
                    </b-col>
                    <b-col cols="2">
                        <b-link @click="$refs.drawer_team_members_details.viewTeamMembersDetails()" class="float-right py-0 text-primary">Edit</b-link>
                    </b-col>
                </b-row>
            </b-card-header>
            <b-container class="pb-2">
                <b-row>
                    <b-col cols="12">
                        <div class="d-flex align-items-center mb-2">
                            <b class="pr-3 text-gray">ID</b>
                            <p class="mb-0">{{ current_team.hub_team_id }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="mr-3"><g fill="none" stroke="#A4B0C0" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M11 12a1 1 0 1 0 2 0 1 1 0 1 0-2 0"/><path d="M12 7a5 5 0 1 0 5 5"/><path d="M13 3.055A9 9 0 1 0 20.941 11"/><path d="M15 6v3h3l3-3h-3V3zm0 3-3 3"/></g></svg>
                            <p class="mb-0">RM{{ current_team.teams_kpi_achievement_amount | moneyFormatter }}</p>
                        </div>
                        <div class="d-flex align-items-center mb-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" class="mr-3"><path fill="#A4B0C0" d="M14.75 15c.966 0 1.75.784 1.75 1.75l-.001.962c.117 2.19-1.511 3.297-4.432 3.297-2.91 0-4.567-1.09-4.567-3.259v-1c0-.966.784-1.75 1.75-1.75h5.5Zm-11-5h4.376a4.007 4.007 0 0 0 1.067 3.85l.162.151L9.25 14a2.75 2.75 0 0 0-2.649 2.008l-.034.001C3.657 16.009 2 14.919 2 12.75v-1c0-.966.784-1.75 1.75-1.75Zm16.5 0c.966 0 1.75.784 1.75 1.75l-.001.962c.117 2.19-1.511 3.297-4.432 3.297l-.169-.002a2.756 2.756 0 0 0-2.451-2L14.75 14l-.105.001a3.99 3.99 0 0 0 1.229-4L20.25 10ZM12 8a3 3 0 1 1 0 6 3 3 0 0 1 0-6ZM6.5 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm11 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"/></svg>
                            <p class="mb-0">{{ current_team.team_members_counts }} Members</p>
                        </div>
                    </b-col>
                    <b-col cols="12" v-if="current_team.team_members.length > 0">
                        <h5 class="font-weight-500 text-dark mb-0">Members' Performance</h5>
                    </b-col>
                </b-row>
                <b-row class="member-performance text-muted" v-if="current_team.team_members.length > 0">
                    <b-col cols="1" class="px-1 py-2 text-center"><span>#</span></b-col>
                    <b-col cols="4" class="px-1 py-2">Member</b-col>
                    <b-col cols="5" class="px-1 py-2">Pre-Rev./KPI(RM)</b-col>
                    <b-col cols="2" class="px-1 py-2">Act. RP</b-col>
                </b-row>
                <div v-for="(member, index) in current_team.team_members" :key="index">
                    <b-row class="member-performance border rounded mb-2">
                        <b-col cols="1" class="px-1 py-2 text-center align-self-center">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 1024 1024" v-if="index < 3"><path :fill="(index === 0) ? '#F5D21F' : (index === 1) ? '#D8D8D8' : (index === 2) ? '#AD8E51' : 'none'" d="M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z"/></svg> -->
                            <span>{{ index + 1 }}</span>
                        </b-col>
                        <b-col cols="4" class="px-1 py-2 d-flex align-items-center">
                            <b-avatar src="https://placekitten.com/300/300" size="24px" class="mr-2"></b-avatar>
                            <p class="mb-0 name">{{ member.name }}</p>
                        </b-col>
                        <b-col cols="5" class="px-1 py-2 align-self-center">
                            <span class="pb-1">{{ member.total_revenue_point | moneyFormatter}} ({{ (member.total_revenue_point / current_team.team_members_kpi_achievement_amount_100 * 100) | moneyFormatter }}%)<span class="text-muted"> / {{ current_team.team_members_kpi_achievement_amount_100 | moneyFormatter }}</span></span>
                            <b-progress height="7px" :value="member.total_revenue_point / current_team.team_members_kpi_achievement_amount_100 * 100" :max="100.00" class="w-75" variant="success"></b-progress>
                        </b-col>
                        <b-col cols="2" class="px-1 py-2 align-self-center">
                            RM {{ member.actual_total_revenue_point | moneyFormatter}}
                        </b-col>
                    </b-row>
                </div>
            </b-container>
        </b-card>

        <!-- Drawer for Team Members Details -->
        <drawer-team-members-details ref="drawer_team_members_details"></drawer-team-members-details>
    </div>
</template>
<script>
import DrawerTeamMembersDetails from '@/views/Commission/Hub/HubProfile/OffCanvasDetails/DrawerTeamMembersDetails'
import { mapState } from 'pinia'
import { useHubStore } from '@/stores/hubStore'

export default {
    components: {
        DrawerTeamMembersDetails
    },
    computed: {
        ...mapState(useHubStore,['current_team'])
    },
}
</script>